import React from 'react';
import { DataTable, OverflowMenu, OverflowMenuItem } from 'carbon-components-react';
import funcTranslateHelper from '../../../../i18next/funcTranslateHelper';

const {
  TableCell
} = DataTable;

const OverflowMenuCell = ({ id, onEdit, onDelete }) => (
  <TableCell>
    <OverflowMenu flipped className='data-table_overflow-menu'>
      <OverflowMenuItem primaryFocus itemText={funcTranslateHelper('Editar')} onClick={() => onEdit(id)} />
      <OverflowMenuItem itemText={funcTranslateHelper('Eliminar')} onClick={() => onDelete(id)} />
    </OverflowMenu>
  </TableCell>
);

export default OverflowMenuCell;
